export const types = {
    login: "LOGIN",
    logout: "LOGOUT",
};
